var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorporateFareBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_25325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_25325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 18C2.87496 18 2.4826 17.8368 2.15621 17.5104C1.82982 17.184 1.66663 16.7917 1.66663 16.3333V4.66667C1.66663 4.20833 1.82982 3.81597 2.15621 3.48958C2.4826 3.16319 2.87496 3 3.33329 3H8.33329C8.79163 3 9.18399 3.16319 9.51038 3.48958C9.83677 3.81597 9.99996 4.20833 9.99996 4.66667V6.33333H16.6666C17.125 6.33333 17.5173 6.49653 17.8437 6.82292C18.1701 7.14931 18.3333 7.54167 18.3333 8V16.3333C18.3333 16.7917 18.1701 17.184 17.8437 17.5104C17.5173 17.8368 17.125 18 16.6666 18H3.33329ZM3.33329 16.3333H8.33329V14.6667H3.33329V16.3333ZM3.33329 13H8.33329V11.3333H3.33329V13ZM3.33329 9.66667H8.33329V8H3.33329V9.66667ZM3.33329 6.33333H8.33329V4.66667H3.33329V6.33333ZM9.99996 16.3333H16.6666V8H9.99996V16.3333ZM12.5 11.3333C12.2638 11.3333 12.0659 11.2535 11.9062 11.0938C11.7465 10.934 11.6666 10.7361 11.6666 10.5C11.6666 10.2639 11.7465 10.066 11.9062 9.90625C12.0659 9.74653 12.2638 9.66667 12.5 9.66667H14.1666C14.4027 9.66667 14.6007 9.74653 14.7604 9.90625C14.9201 10.066 15 10.2639 15 10.5C15 10.7361 14.9201 10.934 14.7604 11.0938C14.6007 11.2535 14.4027 11.3333 14.1666 11.3333H12.5ZM12.5 14.6667C12.2638 14.6667 12.0659 14.5868 11.9062 14.4271C11.7465 14.2674 11.6666 14.0694 11.6666 13.8333C11.6666 13.5972 11.7465 13.3993 11.9062 13.2396C12.0659 13.0799 12.2638 13 12.5 13H14.1666C14.4027 13 14.6007 13.0799 14.7604 13.2396C14.9201 13.3993 15 13.5972 15 13.8333C15 14.0694 14.9201 14.2674 14.7604 14.4271C14.6007 14.5868 14.4027 14.6667 14.1666 14.6667H12.5Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateFareBlue);
export default __webpack_public_path__ + "static/media/icon_corporate_fare_blue.9757427162b2aeeebf05b683c883370f.svg";
export { ForwardRef as ReactComponent };